export const ProjectJobs = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.2"
      height="24"
      viewBox="0 0 19.2 24"
    >
      <path
        id="Path_65878"
        data-name="Path 65878"
        d="M6.4,24.5H18.6A3.543,3.543,0,0,0,22.1,21V4A3.543,3.543,0,0,0,18.6.5H6.4A3.543,3.543,0,0,0,2.9,4V21a3.543,3.543,0,0,0,3.5,3.5ZM12.5,3.6a2.862,2.862,0,0,1,2.8,2.8,2.862,2.862,0,0,1-2.8,2.8,2.8,2.8,0,1,1,0-5.6Zm-5,10.8a5.207,5.207,0,0,1,3-3.6,4.477,4.477,0,0,0,2,.4,6.465,6.465,0,0,0,2-.4,5.207,5.207,0,0,1,3,3.6,1.442,1.442,0,0,1-.3,1.3,1.984,1.984,0,0,1-1.3.6H9.1a1.612,1.612,0,0,1-1.3-.6A1.442,1.442,0,0,1,7.5,14.4Zm-.6,5H18.2a.945.945,0,0,1,1,1,1,1,0,0,1-1,1H6.9a1.075,1.075,0,0,1-1-1,.945.945,0,0,1,1-1Z"
        transform="translate(-2.9 -0.5)"
        fill={primaryFontColor}
      />
    </svg>
  );
};
